export const STATE = "stateId";
export const CONTENT = "contentRichText";
export const STATUS = "status";
